/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientsidgeneratePdfGeneratePdf from './PatientsidgeneratePdfGeneratePdf';

/**
 * The IdGeneratePdfBody model module.
 * @module model/IdGeneratePdfBody
 * @version v0.3
 */
export default class IdGeneratePdfBody {
  /**
   * Constructs a new <code>IdGeneratePdfBody</code>.
   * @alias module:model/IdGeneratePdfBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IdGeneratePdfBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IdGeneratePdfBody} obj Optional instance to populate.
   * @return {module:model/IdGeneratePdfBody} The populated <code>IdGeneratePdfBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IdGeneratePdfBody();
      if (data.hasOwnProperty('generate_pdf'))
        obj.generatePdf = PatientsidgeneratePdfGeneratePdf.constructFromObject(data['generate_pdf']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PatientsidgeneratePdfGeneratePdf} generatePdf
 */
IdGeneratePdfBody.prototype.generatePdf = undefined;

